import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";
import { expenseCategoryType } from "types/expenseCategory";

export const getExpenseCategories = async () => {
  return axios
    .get(ServiceEndpoints.EXPENSE_CATEGORY)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const createExpenseCategory = async (data: { name: string }) => {
  return axios
    .post(ServiceEndpoints.EXPENSE_CATEGORY, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const updateExpenseCategory = async (
  id: string,
  data: expenseCategoryType
) => {
  const { ...categoryData } = data;

  // Send a PUT request to the API endpoint to update the expense-category
  return axios
    .put(`${ServiceEndpoints.EXPENSE_CATEGORY}/${id}`, categoryData)
    .then(({ data }) => {
      // Return the response data upon a successful update
      return Promise.resolve(data);
    })
    .catch((err) => {
      // Handle errors by rejecting the promise
      return Promise.reject(err);
    });
};

export const getExpenseCategoryById = async (id: string) => {
  return axios
    .get(ServiceEndpoints.EXPENSE_CATEGORY + "/" + id)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const deleteExpenseCategory = async (id: string) => {
  return axios
    .delete(ServiceEndpoints.EXPENSE_CATEGORY + "/" + id)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
